var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalender(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.502,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8002 7.41132H8.76611V5.61932H11.8002V7.41132ZM12.2372 12.6983H1.82214C1.18214 12.6983 0.664062 12.1723 0.664062 11.5233V2.71133C0.664062 2.62933 1.18214 1.53633 1.82214 1.53633H2.97913V2.71133H1.82214V11.5233H12.2372V2.71133H10.5011V3.88632H9.34412V0.361328H10.5011V1.53633H12.2372C12.8772 1.53633 13.3951 2.62933 13.3951 2.71133V11.5233C13.3951 12.1723 12.8772 12.6983 12.2372 12.6983ZM8.18713 10.3483H5.87207V7.99832H8.18713V10.3483ZM5.87207 5.61932H8.18713V7.41132H5.87207V5.61932ZM4.71509 3.88632H3.55811V0.361328H4.71509V1.53633H8.76611V2.71133H4.71509V3.88632ZM5.29309 10.3483H2.97913V7.99832H5.29309V10.3483ZM2.97913 5.61932H5.29309V7.41132H2.97913V5.61932Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalender);
export default __webpack_public_path__ + "static/media/calender.794920972e6e2e393f77b2d4c4889884.svg";
export { ForwardRef as ReactComponent };